import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tafk34eq47: FaireBrandEntity = {
  token: "b_tafk34eq47",
  type: "brand",
  name: "From The Heart",
  avatarUrl:
    "https://cdn.faire.com/fastly/12a31de9cf7d334399768316883233d014c26315c5ac47b7c5ce8967e5a17fe5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5596a9473911194f7024e6c64756a94fd24fd80bfe385b4282730a560d12c8d2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/12a31de9cf7d334399768316883233d014c26315c5ac47b7c5ce8967e5a17fe5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5596a9473911194f7024e6c64756a94fd24fd80bfe385b4282730a560d12c8d2.jpeg",
  location: "North Little Rock, AR, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 124,
  isTopShop: true,
  isInsider: true,
  description:
    "From the Heart is a jewelry brand focused on connecting our customers to their passions. We specialize in collegiate jewelry, custom jewelry, and fashion jewelry. We are currently licensed with over 100 colleges and universities across the country!  All of our jewelry is designed by our art team in Arkansas and Oklahoma, and we work with manufacturers around the globe to source our jewelry components. Our team of working moms and grandmothers in Broken Arrow, Oklahoma assembles each piece by hand for you when you order. Our goal is to help you express your passion and tell your personal story through the jewelry that you wear! Have additional questions? We would love to talk to you! Give us a call [redacted-phone].  We are open Monday-Friday 8:30am-5:00pm CST. If you happen to catch us after hours, please leave us a message or send us a message here and we will get back with you just as quickly as we can!! ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:28.498Z",
    importedBy: "entity-db-cli",
  },
};
